module.exports = __webpack_public_path__ + "2dfa0e0fae7663a9ee1f5acf14614666.jpg";